const SUCCESS = { header: 'SUCCESS!', timestamp: new Date().toLocaleTimeString(), color: 'green' };
const FAILED = { header: 'FAILURE!', timestamp: new Date().toLocaleTimeString(), color: 'red' };

export { SUCCESS, FAILED };
